<template>
    <div>
        <h1>Login</h1>
        <input type="text" placeholder="Username" v-model="username" />
        <input type="text" placeholder="Password" v-model="password" />
        <input type="button" @click="login" value="Login" />
        <p v-if="msg">{{ msg }}</p>
    </div>
</template>
<script>
import AuthService from '@/services/AuthService.js';
export default {
    data() {
        return {
            username: '',
            password: '',
            msg: ''
        };
    },
    methods: {
        async login() {
            try {
                const credentials = {
                    email: this.username,
                    password: this.password
                };
                const response = await AuthService.login(credentials);
                this.msg = response.msg;
                const token = response.data.token;
                const user = response.data.name;
                const unit = response.data.unit;
                const role = response.data.role;
                this.$store.dispatch('login', { token, user, unit, role });
                this.$router.push('/unitdashboard');
            } catch (error) {
                this.msg = error.response.data.msg;
            }
        }
    }
};
</script>
